import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { IPostElementProps } from '../../../../types/types'
import DeleteIcon from '@mui/icons-material/Delete'

import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import DialogComponent from '@professocial/professocialFormComponents/FormComponents/DialogComponent'

import { deletePostInitiated } from '../../../../../store/facebook/facebook.actions'
import { namedRequestData } from '../../../../../store/common/common.selectors'
import { PostingRootState } from '../../../../../store/postingRoot.reducer'
import { ActionCall } from '@professocial/professocialTypes/types/commonTypes'
import { DeletePostRequest, NetworkType } from '@3m5/sm_publish-frontend-api'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    textTransform: 'inherit',
    paddingTop: '9px',
    width: '100%',
    '& .MuiButton-startIcon>*:nth-of-type(1)': {
      fontSize: '24px',
    },
  },
}))

const DeletePost: React.FC<IPostElementProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const dispatchDeletePost = useCallback((params: DeletePostRequest) => dispatch(deletePostInitiated(params)), [dispatch])
  const actionOnDeletePost: ActionCall | undefined = useSelector((state: PostingRootState) => namedRequestData(state, deletePostInitiated.type))
  const [showDeletePostWarning, setShowDeletePostWarning] = useState<boolean>(false)

  const deletePost = () => {
    if (props.networkPageId && props.networkType) {
      const params: DeletePostRequest = {
        networkPageId: props.networkPageId,
        networkType: props.networkType,
        networkPostId: props.post.networkPostId || props.post.id, // TODO remove props.post.id when Linked in data is right
      }
      dispatchDeletePost(params)
    }
  }

  return (
    <>
      <ButtonComponent
        text={t('networkContentDashboard:deletePost')}
        startIcon={<DeleteIcon />}
        className={classes.root}
        variant='text'
        disabled={actionOnDeletePost?.inProgress && (actionOnDeletePost?.id !== props.post.networkPostId || actionOnDeletePost?.id !== props.post.id)}
        color='info'
        onClick={() => setShowDeletePostWarning(true)}
      />
      <DialogComponent
        type='error'
        title={t('networkContentMessages:deleteWarningTitle')}
        message={t('networkContentMessages:deletePostWarning')}
        open={showDeletePostWarning}
        confirmLabel={t('networkContentCommon:delete')}
        cancelLabel={t('networkContentCommon:cancel')}
        autoClose={false}
        requestActions
        onClose={() => setShowDeletePostWarning(false)}
        onCancel={() => setShowDeletePostWarning(false)}
        onConfirm={() => {
          setShowDeletePostWarning(false)
          deletePost()
        }}
      />
    </>
  )
}

export default DeletePost
